export default {
  common:{
    share:'Share',
    read_more:'Read more',
    more: 'Mehr',
    less: 'Less',
    blog: 'Blog',

  },
  blog:{
    min_read:'{min}  min read',
    related_articles:'Related articles',
    blog_name: `THE SEU <span class="blog-text-highlight" style="margin-left: 8px;"> {blog}</span>`,
    search:'search',
    all_categories:'All',
    no_posts:'No posts found'

  },
  footer:{

    links:'links',
    social_media:'Social Media',
    sitemap:'sitemap',
    seu:'SEU',
    challenges:'Challenges',
    strategy:'Strategy',
    services:'Services',
    engineering:'Engineering',
    about:'About',
    blog:'Blog',
    contact:'Contact',
    arrival:'Directions',
    media:'Media',
    newsletter:'Newsletter',
    jobs:'Jobs',
    imprint:'Site info',
    terms:'Privacy',
    copyright:'Copyright © 2023 Swiss Engineers United. All rights reserved.',


  },
  newsletter: {
    title:'',
    subtitle:'Current industry knowledge straight to your mailbox',
    enter_email:'enter your e-mail',
    subscribe_btn:'Subscribe',
    email_required:'Valid email is required'

  }
}
